$(function() {
    'use strict';

    var $paypal_form = $('.paypal-form > form');

    $(document).on('click', '.cta-tool-action > a', function(eventObj) {
        eventObj.preventDefault();
        $paypal_form.submit();
    });

    $(document).on('click', '.banner-variant-cta-tool-single .banner-button a', function(eventObj) {
        eventObj.preventDefault();
        $paypal_form.submit();
    });

    $(document).on('click', '.js-paypal-form-submit', function(eventObj) {
        eventObj.preventDefault();
        $paypal_form.submit();
    });
});
